import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { GraphQLModule } from './graphql/graphql.module';
import {
  HttpClientModule,
  HTTP_INTERCEPTORS,
  HttpClient,
} from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthInterceptor } from './auth/interceptors/auth.interceptor';
import { ErrorInterceptor } from './auth/interceptors/error.interceptor';
import { HeaderModule } from './shared/components/header/header.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { AppService } from './app.service';
import { ApplyContextClassModule } from './shared/directives/apply-context-class/apply-context-class.module';
import { AdminSidebarModule } from './shared/components/admin-sidebar/admin-sidebar.module';
import { ShowOnContextModule } from './shared/directives/show-on-context/show-on-context.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProgressBarInterceptor } from './shared/interceptors/progress-bar.interceptor';

import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatIconModule } from '@angular/material/icon';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { FooterModule } from './shared/components/footer/footer.module';
import { HeaderPartialModule } from './shared/components/header-partial/header-partial.module';
import { ApplyForJobModule } from './apply-for-job/apply-for-job.module';
import { AuthService } from './auth/auth.service';
import { UserService } from './shared/services/user.service';
import { provideRouter } from '@angular/router';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, '/assets/i18n/', '.json');
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    GraphQLModule,
    HttpClientModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    HeaderModule,
    FlexLayoutModule,
    ApplyContextClassModule,
    AdminSidebarModule,
    ShowOnContextModule,
    MatProgressBarModule,
    MatSnackBarModule,
    FooterModule,
    MatIconModule,
    HeaderPartialModule,
    ApplyForJobModule,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ProgressBarInterceptor,
      multi: true,
    },
    AppService,
    UserService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
